export default {
  email: {
    presence: { allowEmpty: false, message: "is required" },
    email: {
      message: "is not valid"
    },
    length: {
      maximum: 55
    }
  },
  password: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 55
    }
  },
  c_password: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 55
    },
    equality: {
      attribute: "password",
      message: "is not equal to password"
    }
  }
};
